import React, { useState } from "react";
import { Users, Search } from "react-feather";
import DetailModal from "./DetailModal";

const CustomerIntelligence = () => {
  const [selectedHeatMapItem, setSelectedHeatMapItem] = useState(null);
  const [selectedDetailModal, setSelectedDetailModal] = useState(null);

  const customerSegmentHeatMap = [
    {
      name: "Large Joint Reconstruction",
      players: 4,
      companies: [
        "Stryker",
        "Johnson & Johnson MedTech",
        "Zimmer Biomet",
        "Smith & Nephew",
      ],
      color: "custom-danger",
      marketSize: "$51.6B (2024, 4.8% CAGR)",
      dataKey: "custseg-0",
    },
    {
      name: "Robotic & Navigation Surgery Platforms",
      players: 4,
      companies: [
        "Stryker",
        "Zimmer Biomet",
        "Johnson & Johnson MedTech",
        "Smith & Nephew",
      ],
      color: "custom-danger",
      marketSize: "$11.1B (2024, 16.5% CAGR)",
      dataKey: "custseg-1",
    },
    {
      name: "Sports Medicine & Arthroscopy",
      players: 4,
      companies: [
        "Stryker",
        "Smith & Nephew",
        "Arthrex",
        "Zimmer Biomet",
      ],
      color: "custom-danger",
      marketSize: "$6.79B (2024, 6.8% CAGR)",
      dataKey: "custseg-2",
    },
    {
      name: "Neurovascular Stroke Intervention",
      players: 2,
      companies: ["Stryker", "Johnson & Johnson MedTech"],
      color: "custom-warning",
      marketSize: "$4.64B (2025, 9.3% CAGR)",
      dataKey: "custseg-3",
    },
    {
      name: "ASC Digital Enablement",
      players: 3,
      companies: [
        "Stryker",
        "Johnson & Johnson MedTech",
        "Smith & Nephew",
      ],
      color: "custom-info",
      marketSize: "$7.2B (2025F, 27.6% CAGR)",
      dataKey: "custseg-4",
    },
  ];

  const customerIntelligence = {
    stryker: {
      dataDepth: "Leader",
      segmentation: "Leader",
      personalization: "Leader",
      voiceOfCustomer: "Strong",
      highlight:
        "Score 8.8/10 (Market Leader) – Record Q3 2025 Mako installs plus 9.5% organic growth keep ASC knees/hips locked in.",
      quote:
        "“Mako 4 and the upcoming shoulder/spine playbook make robotics our crown-jewel bridge between inpatient IDNs and high-volume ASCs.”",
    },
    jnjmedtech: {
      dataDepth: "Leader",
      segmentation: "Leader",
      personalization: "Strong",
      voiceOfCustomer: "Strong",
      highlight:
        "Score 8.2/10 (High Threat) – DePuy Synthes spin-out funds VELYS expansion and lets J&J buy share across bundled ortho deals.",
      quote:
        "“Separating orthopaedics frees capital while VELYS’ CT-free workflows court surgeons that want digital precision without footprint bloat.”",
    },
    zimmer: {
      dataDepth: "Strong",
      segmentation: "Strong",
      personalization: "Strong",
      voiceOfCustomer: "Moderate",
      highlight:
        "Score 7.7/10 (Medium Threat) – Monogram adds semi-autonomous robotics to the ROSA stack, tightening Zimmer’s hold on tech-first IDNs.",
      quote:
        "“ROSA plus Monogram’s CT-based autonomy is Zimmer’s bid to own every robotics preference card from imageless to fully guided.”",
    },
    smithnephew: {
      dataDepth: "Strong",
      segmentation: "Strong",
      personalization: "Strong",
      voiceOfCustomer: "Strong",
      highlight:
        "Score 6.6/10 (Medium Threat) – 12-point plan restored supply discipline and pushed CORI installs past 1,000 with new CORIOGRAPH planning.",
      quote:
        "“Image-agnostic CORI plus EVOS trauma depth gives Smith+Nephew a nimble toolkit for surgeons fleeing rigid vendor bundles.”",
    },
    arthrex: {
      dataDepth: "Moderate",
      segmentation: "Strong",
      personalization: "Leader",
      voiceOfCustomer: "Leader",
      highlight:
        "Score 6.1/10 (Low Threat) – Synergy Power and NanoNeedle 2.0 keep Arthrex embedded with sports specialists despite limited scale.",
      quote:
        "“By owning visualization, biologics and education, Arthrex turns every lab course into a sticky, procedure-specific micro-franchise.”",
    },
  };

  const companies = [
    { id: "stryker", name: "Stryker", bgColor: "success" },
    {
      id: "jnjmedtech",
      name: "Johnson & Johnson MedTech",
      bgColor: "danger",
    },
    { id: "zimmer", name: "Zimmer Biomet", bgColor: "primary" },
    { id: "smithnephew", name: "Smith & Nephew", bgColor: "info" },
    { id: "arthrex", name: "Arthrex", bgColor: "secondary" },
  ];

  return (
    <div>
      <style>{`
        .segment-item {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .segment-item:hover {
          transform: scale(1.02);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
        .selected-segment {
          transform: scale(1.05);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        .intelligence-card {
          border-radius: 8px;
          padding: 12px 16px;
          border: 1px solid;
        }
        .comp_map_block{
          border-bottom: 1px solid #e9ecef;
          background-color: #fff;
          padding: 12px 16px;
          border: solid 1px #98a4aa33;
          border-radius: 8px;
        }
      .comp_subhead{
          font-size:14px;
          font-weight:600 !Important;
        }
        .comp_head_new{
          color:#2d343d !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
          margin-bottom:5px;
        }
        .comp_subhead_new{
          color:#64748B !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:400;
          margin-bottom:5px;

        }
        .comp_head_number{
          color:#363b4b !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
        }
        .comp_subhead{
          font-size:14px;
          font-weight:600 !Important;
        }
        .comp_head_new{
          color:#2d343d !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
          margin-bottom:5px;
        }
        .comp_subhead_new{
          color:#64748B !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:400;
          margin-bottom:5px;

        }
        .comp_head_number{
          color:#363b4b !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
        }
        .bg-custom-danger{
          background-color: #fef2f2;
          border-left: 4px solid #b91c1c !important;
        }
        .bg-custom-danger-only{
          background-color: #b91c1c;
        }
        .bg-custom-info{
          background-color: #eff6ff;
          border-left: 4px solid #1e74e6 !important;
        }
        .bg-custom-info-only{
          background-color: #1e74e6;
        }
        .bg-custom-success{
          background-color: #f0fdf4;
          border-left: 4px solid #15803d !important;
        }
        .bg-custom-success-only{
          background-color: #15803d;
        }
        .bg-custom-warning-only{
          background-color: #CFAB69;
        }
        .bg-custom-warning{
          background-color: #feebc89c;
          border-left: 4px solid #CFAB69 !important;
        }
        .score_inter{
          font-weight: 400;
    font-size: 12px;
    background-color: #f0f4fa;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.6);
    /* margin-top: 5px; */
    margin-bottom: 20px;
    padding: 12px 8px 12px 12px;
    border-radius: 8px;
        }


      `}</style>

      <DetailModal
        selectedDetailModal={selectedDetailModal}
        setSelectedDetailModal={setSelectedDetailModal}
      />

      {/* Customer Segment Heat Map */}
      <div className="card border-0 mb-4">
        <div className="card-body comp_map_block">
          <h3 className="exe_summary mb-4">Customer Segment Heat Map</h3>

          <div>
            <div className="d-flex align-items-center gap-2 text-purple fw-bold small mb-3 font13">
              <Users size={16} />
              Key Customer Segments
            </div>
            <div className="row g-3">
              {customerSegmentHeatMap.map((item, idx) => {
                const itemKey = item.dataKey || `custseg-${idx}`;
                const isSelected = selectedHeatMapItem === itemKey;

                return (
                  <div key={idx} className="col-md-4">
                    <div
                      className={`segment-item bg-${
                        item.color
                      } bg-opacity-10 border-start border-${
                        item.color
                      } border-2 p-3 rounded ${
                        isSelected ? "selected-segment" : ""
                      }`}
                      onClick={() =>
                        setSelectedHeatMapItem(isSelected ? null : itemKey)
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="flex-grow-1">
                          <div className="comp_head_new">{item.name}</div>
                          <div className="comp_subhead_new">
                            {item.players} player{item.players > 1 ? "s" : ""} â€¢{" "}
                            {item.players === 4
                              ? "Very crowded"
                              : item.players === 3
                              ? "Competitive"
                              : item.players === 2
                              ? "Moderate"
                              : "Unique"}
                          </div>
                          {item.marketSize && (
                            <div className="comp_head_number">
                              {item.marketSize}
                            </div>
                          )}
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedDetailModal(itemKey);
                          }}
                          className="btn btn-sm btn-link p-0 ms-2"
                          title="Click for detailed analysis"
                        >
                          <Search size={18} className="text-primary" />
                        </button>
                      </div>
                    </div>

                    {isSelected && (
                      <div className="mt-2 ms-2 p-3 bg-white rounded border border-primary border-2 shadow-sm">
                        <div className="small fw-bold mb-2">
                          Companies serving this segment:
                        </div>
                        <div className="d-flex flex-wrap gap-1">
                          {item.companies.map((company, compIdx) => (
                            <span
                              key={compIdx}
                              className={`badge ${
                                company === "Stryker"
                                  ? "bg-success"
                                  : company === "Johnson & Johnson MedTech"
                                  ? "bg-danger"
                                  : company === "Zimmer Biomet"
                                  ? "bg-primary"
                                  : company === "Smith & Nephew"
                                  ? "bg-info"
                                  : "bg-secondary"
                              }`}
                            >
                              {company}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="row g-2 p-3 bg-light rounded mt-3">
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-danger-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Very Crowded</div>
                  <div className="text-muted">4 players</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-info-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Competitive</div>
                  <div className="text-muted">3 players</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-warning-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Moderate</div>
                  <div className="text-muted">2 players</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-success-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Unique</div>
                  <div className="text-muted">1 player</div>
                </div>
              </div>
            </div>
          </div>

          <div className="score_inter mt-2 mb-2">
            <div className="d-flex gap-2">
              <img src="/img/bullseye.png" width="16" height="16"/>
              <div className="small">
                <strong>Customer Segment Battle Map:</strong> Large Joint Reconstruction ($51.6B TAM) stays the slugfest—DePuy’s spin-out and Zimmer’s scale mean no price slack for implants. Robotic & Navigation platforms ($11.1B, 16.5% CAGR) are the future growth flywheel, with Stryker’s Mako 4 lead under siege from ROSA and VELYS. Sports Medicine ($6.79B, 6.8% CAGR) is getting saturated, so watch margin erosion as Arthrex and Smith+Nephew escalate field education. Neurovascular stroke tools ($4.64B, 9.3% CAGR) remain a two-horse race where Stryker’s flow diverters must fend off CERENOVUS launches. ASC digital enablement ($7.2B by 2025, 27.6% CAGR) is the fastest-growing procurement node—software + robotics bundles now decide IDN conversions. <strong>Stryker CROWN JEWELS: Robotic & Navigation is our profit engine; defend the Mako ecosystem in ASCs at all costs.</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Intelligence Grid */}
      <div className="row g-3">
        {companies.map((company) => (
          <div key={company.id} className="col-md-6">
            <div
              className={`intelligence-card bg-${company.bgColor} bg-opacity-10 border-${company.bgColor}`}
            >
              <h4 className="h6 fw-bold font14">{company.name}</h4>
              <div className="mb-2">
                <div className="small text-muted text-uppercase fw-semibold mb-1 font13">
                  Key Strength
                </div>
                <p className="small mb-0 font13">
                  {customerIntelligence[company.id].highlight}
                </p>
              </div>
              <div className="">
                <div className="small fst-italic text-muted font13">
                  "{customerIntelligence[company.id].quote}"
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerIntelligence;